import * as comUtils from 'utils/Common';


export function isLoggedIn() {
  return comUtils.getLocalStorage("api_token") ? true : false;
}

export function getAuthorizationToken() {
  if (!isLoggedIn()) {
    return "";
  }

  return "Token " + comUtils.getLocalStorage("api_token");
}

export function getApiToken() {
  return comUtils.getLocalStorage("api_token") || "";
}

export function isVerified() {
  const isVerified = comUtils.getLocalStorage("is_verified");
  if (comUtils.isBool(isVerified)) return isVerified;
  return true;
}

export function setIsVerified(isVerified) {
  comUtils.setLocalStorage('is_verified', isVerified);
}

export function isMissingPassword() {
  const missingPassword = comUtils.getLocalStorage("missing_password");
  if (comUtils.isBool(missingPassword)) return missingPassword;
  return false;
}

export function setIsSetupUser(missingPassword) {
  comUtils.setLocalStorage('missing_password', missingPassword);
}

export function setLoginDetails(response) {
  comUtils.setLocalStorage('api_token', response['api_token']);
  comUtils.setLocalStorage('account_id', response['account_id']);
  comUtils.setLocalStorage('is_verified', response['is_verified']);
  comUtils.setLocalStorage('missing_password', response['missing_password']);
  comUtils.setLocalStorage('current_product', response['default_product']);
}

export function setAccountId(accountId) {
  comUtils.setLocalStorage('account_id', accountId);
}

export function getAccountId() {
  return comUtils.getLocalStorage("account_id") || "";
}

export function setCurrentProduct(product) {
  comUtils.setLocalStorage('current_product', product);
}

export function getCurrentProduct() {
  return comUtils.getLocalStorage("current_product") || "";
}







